module.exports = __webpack_public_path__ + "static/media/entertain-applause.2c050a65.mp4";